import { Flex, HStack, Text, Button } from '@chakra-ui/react'
import { HiOutlineRefresh } from 'react-icons/hi'

const TopBar = () => {
  const today = new Date().toLocaleDateString('zh-CN', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  return (
    <Flex
      align="center"
      justify="space-between"
      h="full"
    >
      <HStack gap={4}>
        <Text color="text.muted" fontSize="sm" fontWeight="medium">
            {today}
        </Text>
      </HStack>
      <Flex gap={3}>
        <Button
          variant="ghost"
          size="sm"
          color="text.muted"
          _hover={{ color: "text.main", bg: "bg.subtle" }}
        >
          <HiOutlineRefresh />
          刷新数据
        </Button>
      </Flex>
    </Flex>
  )
}

export default TopBar
